import { Injectable } from "@angular/core";
import { CommonService } from "../common.service";

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
}

const MENUITEMS = [
  {
    state: "dashboard",
    name: "Dashboard",
    type: "link",
    icon: "av_timer",
    iconColor: "#FF5959",
    show: true,
  },
  {
    state: "user-management",
    type: "link",
    name: "Users",
    icon: "assistant",
    iconColor: "#FFA72F",
    access: "users",
    show: true,
  },
  {
    state: "operator",
    type: "link",
    name: "Operators",
    icon: "perm_identity",
    iconColor: "#3AB89A",
    access: "operators",
    show: true,
  },
  {
    state: "driver-management",
    type: "link",
    name: "Drivers",
    icon: "directions_car",
    svgIcon: "driver",
    iconColor: "#4A3BD8",
    access: "drivers",
    show: true,
  },
  {
    state: "vehicle",
    type: "link",
    name: "Vehicles",
    icon: "directions_car",
    iconColor: "#CF2D2D",
    access: "vehicles",
    show: true,
  },
  {
    state: "bus",
    type: "link",
    name: "Bus",
    icon: "directions_car",
    iconColor: "#FF5959",
    iconUrl: "assets/images/manageBus.png",
    show: true,
  },
  {
    state: "stop",
    type: "link",
    name: "Stops",
    icon: "directions_car",
    iconColor: "#FF5959",
    iconUrl: "assets/images/busStop.png",
    show: true,
  },
  {
    state: "trips-management",
    type: "link",
    name: "Trips",
    icon: "date_range",
    iconColor: "#C6B63B",
    access: "trips",
    show: true,
  },
  {
    state: "booking",
    type: "link",
    name: "Bookings",
    icon: "date_range",
    iconColor: "#FF5959",

    show: true,
  },
  {
    state: "support-management",
    type: "link",
    name: "Support",
    icon: "accessibility",
    iconColor: "#16bea9",

    show: true,
  },
  // { state:'analytic', name: 'Analytics', type: 'link', icon: 'insert_chart_outlined', iconColor: '#FF5959', show: true },

  // { state: 'roles', type: 'link', name: 'Roles', icon: 'engineering', iconColor: '#91C326', access: 'roles' },

  // { state: 'officer-management', type: 'link', name: ' Enforcement Officers',svgIcon: 'officer', icon: 'traffic', iconColor: '#D54BB9', access: 'EO' },
  // { state: 'reports-management', type: 'link', name: 'Reports', icon: 'subtitles',iconColor: '#FF5959', show: true,access: 'reports' },

  // { state: 'trip', type: 'link', name: 'Trips', icon: 'date_range', iconColor: '#FF5959',iconUrl:'assets/images/ic_trips.png',show: true  }
  // { state:'payout', name: 'Payout', type: 'link', icon: 'av_timer', iconColor: '#FF5959', svgIcon:'payout', show: true,access: 'payout' },
  // { state: 'stakeholder', type: 'link', name: 'Stakeholder', icon: 'group_add', svgIcon: 'expense', iconColor: '#4A3BD8',access: 'stakeholders' },
  // { state: 'passenger', type: 'link', name: 'Passengers', icon: 'emoji_people', iconColor: '#7D0CE4', access: 'passengers' },
  // { state: 'payment-management', type: 'link', name: 'Invoices', icon: 'subtitles', iconColor: '#267A86', access: 'invoice' },

  // { state: 'terminal-management', type: 'link', name: 'Terminal/Bus Park', icon: 'date_range', svgIcon: 'terminal', iconColor: '#448700', access: 'terminals' },
  // { state: 'tracker-management/view-tracker', type: 'link', name: 'Covid-tracker', icon: 'date_range', svgIcon: 'covid', iconColor: '#FF8527', access: 'covidTracker' },
  // { state: 'covid', type: 'link', name: 'Covid-tracker', icon: 'date_range', svgIcon: 'covid', iconColor: '#FF8527', access: 'covidTracker' },
  // { state: 'password', type: 'link', name: 'Change Password', icon: 'lock', iconColor: '#24B5D7', show: true },
];

@Injectable()
export class MenuItems {
  constructor(private commonService: CommonService) {}
  // getMenuitem(): Menu[] {
  //   const menuItems = MENUITEMS;
  //   menuItems.forEach(element => {
  //     if (element.hasOwnProperty('access')) {
  //       const perm = this.commonService.getPermissions(element.access);
  //       element['show'] = perm !== 'H';
  //     }
  //   });
  //   return menuItems;
  // }
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
